function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { orderRefundCompulsoryApi, refundMarkApi, refundOrderDetailApi, orderDetailApi } from '@/api/order';
import { checkPermi } from '@/utils/permission'; // 权限判断函数
import { filterEmpty, refundStatusFilter } from '@/filters';
export default {
  name: 'refundOrderDetail',
  props: {
    //退款单号
    refundOrderNo: {
      type: String,
      default: 0
    },
    //是否显示隐藏
    drawerVisible: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      loadingBtn: false,
      activeName: 'refund',
      direction: 'rtl',
      reverse: true,
      orderDatalist: {},
      loading: false,
      modal2: false,
      result: [],
      resultInfo: {},
      refundInfo: {},
      refundDetail: {},
      batchNo: null,
      orderDetailListAll: [],
      orderDetailList: []
    };
  },
  mounted: function mounted() {
    this.getRefundOrderDetail(this.refundOrderNo);
  },
  methods: {
    checkPermi: checkPermi,
    // 工具：安全转数字
    _toNum: function _toNum(v) {
      return v !== undefined && v !== null && v !== '' && !Number.isNaN(Number(v)) ? Number(v) : NaN;
    },
    filterByBatch: function filterByBatch(list, batchValue) {
      var _this = this;
      var source = Array.isArray(list) ? list : [];
      var batchNum = this._toNum(batchValue);
      if (Number.isNaN(batchNum)) return source;
      return source.filter(function (item) {
        return _this._toNum(item && item.batchNo) === batchNum;
      });
    },
    // 获取与当前行同 batchNo 的票务映射集合（用于子项展示）
    matchMappingsForRow: function matchMappingsForRow(row) {
      if (!row) return [];
      var rowMappings = Array.isArray(row.ticketOrderMappingList) && row.ticketOrderMappingList.length ? row.ticketOrderMappingList : null;
      var list = rowMappings || (Array.isArray(this.refundInfo.ticketOrderMappingList) ? this.refundInfo.ticketOrderMappingList : []);
      if (!list.length) return [];
      return this.filterByBatch(list, row.batchNo);
    },
    // 便捷方法：直接返回映射数组
    getBatchMappings: function getBatchMappings(row) {
      return this.matchMappingsForRow(row);
    },
    // 是否存在子项：仅当当前行为该 batchNo 的第一条时展示（避免重复展开）
    hasSubItems: function hasSubItems(row, rowIndex) {
      var _this2 = this;
      if (!this.isTicketOrder()) return false;
      var b = this._toNum(row && row.batchNo);
      if (Number.isNaN(b)) return false;
      var mappings = this.matchMappingsForRow(row);
      if (!mappings.length) return false;
      var siblingsIdx = (this.orderDetailList || []).map(function (r, i) {
        return _this2._toNum(r && r.batchNo) === b ? i : -1;
      }).filter(function (i) {
        return i !== -1;
      });
      return siblingsIdx.length > 0 && rowIndex === siblingsIdx[0];
    },
    // 是否门票类订单（优先以退款详情的票务映射判断，其次以商户类型=30判断）
    isTicketOrder: function isTicketOrder() {
      var hasMapping = Array.isArray(this.refundInfo.ticketOrderMappingList) && this.refundInfo.ticketOrderMappingList.length > 0;
      var merType = this.refundInfo.orderInfoVo ? this.refundInfo.orderInfoVo.merchantType : null;
      return hasMapping || Number(merType) === 30;
    },
    getVerifyLabel: function getVerifyLabel() {
      if (this.isTicketOrder()) return '核销数量';
      var st = this.refundInfo.orderInfoVo ? this.refundInfo.orderInfoVo.shippingType : null;
      return Number(st) === 2 ? '核销数量' : '发货数量';
    },
    getVerifyCount: function getVerifyCount(row, rowIndex) {
      var _this3 = this;
      if (this.isTicketOrder()) {
        var sameBatchMappings = this.matchMappingsForRow(row);
        if (!sameBatchMappings.length || !row) return 0;
        var b = this._toNum(row.batchNo);
        if (Number.isNaN(b)) return 0;
        var siblingsIdx = (this.orderDetailList || []).map(function (r, i) {
          return _this3._toNum(r && r.batchNo) === b ? i : -1;
        }).filter(function (i) {
          return i !== -1;
        });
        var localIndex = siblingsIdx.indexOf(rowIndex);
        var verifiedCount = sameBatchMappings.filter(function (m) {
          return Number(m.status) === 1;
        }).length;
        return localIndex > -1 && localIndex < verifiedCount ? 1 : 0;
      }
      return row && (row.deliveryNum || 0);
    },
    getVerifyDisplayText: function getVerifyDisplayText(row, rowIndex) {
      var _this4 = this;
      if (!this.isTicketOrder()) return this.getVerifyCount(row, rowIndex);
      var b = this._toNum(row && row.batchNo);
      if (Number.isNaN(b)) return this.getVerifyCount(row, rowIndex);
      var sameBatch = this.matchMappingsForRow(row);
      var verified = sameBatch.filter(function (m) {
        return Number(m.status) === 1;
      }).length;
      var total = sameBatch.length;
      var siblingsIdx = (this.orderDetailList || []).map(function (r, i) {
        return _this4._toNum(r && r.batchNo) === b ? i : -1;
      }).filter(function (i) {
        return i !== -1;
      });
      if (siblingsIdx.length > 0 && rowIndex === siblingsIdx[0]) return "".concat(verified, "/").concat(total);
      return this.getVerifyCount(row, rowIndex);
    },
    applyBatchFilter: function applyBatchFilter(detailList) {
      var list = Array.isArray(detailList) ? detailList : [];
      var filteredDetails = this.filterByBatch(list, this.batchNo);
      var mappingList = Array.isArray(this.refundInfo.ticketOrderMappingList) ? this.refundInfo.ticketOrderMappingList : [];
      return filteredDetails.map(function (detail) {
        return _objectSpread(_objectSpread({}, detail), {}, {
          ticketOrderMappingList: mappingList
        });
      });
    },
    handleClose: function handleClose() {
      this.$emit('onClosedrawerVisible');
    },
    // 备注
    onOrderMark: function onOrderMark() {
      var _this5 = this;
      this.$modalPrompt('textarea', '退款单备注', this.refundInfo.platformRemark).then(function (V) {
        refundMarkApi({
          remark: V,
          refundOrderNo: _this5.refundOrderNo
        }).then(function () {
          _this5.$message.success('操作成功');
        });
      });
    },
    // 获取订单退款信息
    getRefundOrderDetail: function () {
      var _getRefundOrderDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(id) {
        var res, refund, currentBatchNo, mappingSource, filteredMappings, formattedRefund, vo, fallbackList, orderNo, detailList, detail, dl, normalizedList, _t, _t2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.loading = true;
              _context.p = 1;
              _context.n = 2;
              return refundOrderDetailApi(id);
            case 2:
              res = _context.v;
              refund = res || {};
              currentBatchNo = refund && Object.prototype.hasOwnProperty.call(refund, 'batchNo') ? refund.batchNo : null;
              mappingSource = Array.isArray(refund.ticketOrderMappingList) ? refund.ticketOrderMappingList : [];
              filteredMappings = this.filterByBatch(mappingSource, currentBatchNo);
              formattedRefund = _objectSpread(_objectSpread({}, refund), {}, {
                ticketOrderMappingList: filteredMappings
              });
              this.refundInfo = formattedRefund;
              this.refundDetail = formattedRefund;
              this.batchNo = currentBatchNo;
              vo = refund && refund.orderInfoVo || {};
              fallbackList = Array.isArray(vo.orderDetailList) ? vo.orderDetailList : [];
              orderNo = refund && refund.orderNo || vo && vo.orderNo;
              detailList = [];
              if (!orderNo) {
                _context.n = 7;
                break;
              }
              _context.p = 3;
              _context.n = 4;
              return orderDetailApi(orderNo);
            case 4:
              detail = _context.v;
              dl = detail && (detail.orderDetailList || detail.data && detail.data.orderDetailList);
              detailList = Array.isArray(dl) ? dl : fallbackList;
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
              detailList = fallbackList;
            case 6:
              _context.n = 8;
              break;
            case 7:
              detailList = fallbackList;
            case 8:
              normalizedList = Array.isArray(detailList) ? detailList : [];
              this.orderDetailListAll = normalizedList;
              this.orderDetailList = this.applyBatchFilter(normalizedList);
              _context.n = 10;
              break;
            case 9:
              _context.p = 9;
              _t2 = _context.v;
              this.orderDetailListAll = [];
              this.orderDetailList = [];
            case 10:
              _context.p = 10;
              this.loading = false;
              return _context.f(10);
            case 11:
              return _context.a(2);
          }
        }, _callee, this, [[3, 5], [1, 9, 10, 11]]);
      }));
      function getRefundOrderDetail(_x) {
        return _getRefundOrderDetail.apply(this, arguments);
      }
      return getRefundOrderDetail;
    }(),
    handlerCompulsoryReturn: function handlerCompulsoryReturn(refundInfo) {
      var _this6 = this;
      this.$confirm("\u786E\u5B9A\u5F3A\u5236\u9000\u6B3E\u3010".concat(refundInfo.refundPrice, "\u3011 \u9000\u6B3E\u5355\uFF0C\u6B64\u64CD\u4F5C\u4E0D\u53EF\u9006\uFF0C\u8BF7\u614E\u91CD\u786E\u8BA4\u540E\u518D\u64CD\u4F5C"), '强制退款提示').then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var result;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return orderRefundCompulsoryApi(refundInfo.refundOrderNo);
            case 1:
              result = _context2.v;
              _this6.$emit('compulsoryReturnSuccess');
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      })));
    }
  }
};